module.exports = __webpack_public_path__ + "img/avatar.f4c8c0bd.png";